// proto/v2/hitl/hitl.proto

// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file hitl/hitl.proto (package lvdr.v2.hitl, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file hitl/hitl.proto.
 */
export const file_hitl_hitl: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_google_protobuf_struct]);

/**
 * @generated from message lvdr.v2.hitl.HITLResponseMsg
 */
export type HITLResponseMsg = Message<"lvdr.v2.hitl.HITLResponseMsg"> & {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * @generated from field: lvdr.v2.hitl.Decision decision = 2;
   */
  decision: Decision;

  /**
   * @generated from field: string message = 3;
   */
  message: string;

  /**
   * @generated from field: google.protobuf.Struct data = 4;
   */
  data?: JsonObject | undefined;
};

/**
 * Describes the message lvdr.v2.hitl.HITLResponseMsg.
 * Use `create(HITLResponseMsgSchema)` to create a new message.
 */
export const HITLResponseMsgSchema: GenMessage<HITLResponseMsg> = /*@__PURE__*/
  messageDesc(file_hitl_hitl, 0);

/**
 * @generated from message lvdr.v2.hitl.HITLPendingRequest
 */
export type HITLPendingRequest = Message<"lvdr.v2.hitl.HITLPendingRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;
};

/**
 * Describes the message lvdr.v2.hitl.HITLPendingRequest.
 * Use `create(HITLPendingRequestSchema)` to create a new message.
 */
export const HITLPendingRequestSchema: GenMessage<HITLPendingRequest> = /*@__PURE__*/
  messageDesc(file_hitl_hitl, 1);

/**
 * @generated from message lvdr.v2.hitl.BudgetHITLResponse
 */
export type BudgetHITLResponse = Message<"lvdr.v2.hitl.BudgetHITLResponse"> & {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * @generated from field: bool approved = 2;
   */
  approved: boolean;

  /**
   * @generated from field: double approved_value = 3;
   */
  approvedValue: number;

  /**
   * @generated from field: string message = 4;
   */
  message: string;
};

/**
 * Describes the message lvdr.v2.hitl.BudgetHITLResponse.
 * Use `create(BudgetHITLResponseSchema)` to create a new message.
 */
export const BudgetHITLResponseSchema: GenMessage<BudgetHITLResponse> = /*@__PURE__*/
  messageDesc(file_hitl_hitl, 2);

/**
 * @generated from message lvdr.v2.hitl.GuidanceResponseMsg
 */
export type GuidanceResponseMsg = Message<"lvdr.v2.hitl.GuidanceResponseMsg"> & {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * @generated from field: google.protobuf.Struct data = 3;
   */
  data?: JsonObject | undefined;
};

/**
 * Describes the message lvdr.v2.hitl.GuidanceResponseMsg.
 * Use `create(GuidanceResponseMsgSchema)` to create a new message.
 */
export const GuidanceResponseMsgSchema: GenMessage<GuidanceResponseMsg> = /*@__PURE__*/
  messageDesc(file_hitl_hitl, 3);

/**
 * @generated from message lvdr.v2.hitl.ToolAuthResponseMsg
 */
export type ToolAuthResponseMsg = Message<"lvdr.v2.hitl.ToolAuthResponseMsg"> & {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * @generated from field: bool approved = 2;
   */
  approved: boolean;

  /**
   * @generated from field: google.protobuf.Struct modified_params = 3;
   */
  modifiedParams?: JsonObject | undefined;

  /**
   * @generated from field: string message = 4;
   */
  message: string;
};

/**
 * Describes the message lvdr.v2.hitl.ToolAuthResponseMsg.
 * Use `create(ToolAuthResponseMsgSchema)` to create a new message.
 */
export const ToolAuthResponseMsgSchema: GenMessage<ToolAuthResponseMsg> = /*@__PURE__*/
  messageDesc(file_hitl_hitl, 4);

/**
 * @generated from message lvdr.v2.hitl.WrapUpResearchMsg
 */
export type WrapUpResearchMsg = Message<"lvdr.v2.hitl.WrapUpResearchMsg"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;
};

/**
 * Describes the message lvdr.v2.hitl.WrapUpResearchMsg.
 * Use `create(WrapUpResearchMsgSchema)` to create a new message.
 */
export const WrapUpResearchMsgSchema: GenMessage<WrapUpResearchMsg> = /*@__PURE__*/
  messageDesc(file_hitl_hitl, 5);

/**
 * @generated from message lvdr.v2.hitl.HITLRequestEvent
 */
export type HITLRequestEvent = Message<"lvdr.v2.hitl.HITLRequestEvent"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string research_id = 2;
   */
  researchId: string;

  /**
   * @generated from field: string node_id = 3;
   */
  nodeId: string;

  /**
   * @generated from field: string task_id = 4;
   */
  taskId: string;

  /**
   * @generated from field: string checkpoint_type = 5;
   */
  checkpointType: string;

  /**
   * @generated from field: string status = 6;
   */
  status: string;

  /**
   * @generated from field: google.protobuf.Struct checkpoint_data = 7;
   */
  checkpointData?: JsonObject | undefined;

  /**
   * @generated from field: string timeout_policy = 8;
   */
  timeoutPolicy: string;

  /**
   * @generated from field: google.protobuf.Timestamp timeout_at = 9;
   */
  timeoutAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */
  createdAt?: Timestamp | undefined;
};

/**
 * Describes the message lvdr.v2.hitl.HITLRequestEvent.
 * Use `create(HITLRequestEventSchema)` to create a new message.
 */
export const HITLRequestEventSchema: GenMessage<HITLRequestEvent> = /*@__PURE__*/
  messageDesc(file_hitl_hitl, 6);

/**
 * @generated from message lvdr.v2.hitl.HITLTimeoutEvent
 */
export type HITLTimeoutEvent = Message<"lvdr.v2.hitl.HITLTimeoutEvent"> & {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * @generated from field: string research_id = 2;
   */
  researchId: string;

  /**
   * @generated from field: string timeout_policy = 3;
   */
  timeoutPolicy: string;
};

/**
 * Describes the message lvdr.v2.hitl.HITLTimeoutEvent.
 * Use `create(HITLTimeoutEventSchema)` to create a new message.
 */
export const HITLTimeoutEventSchema: GenMessage<HITLTimeoutEvent> = /*@__PURE__*/
  messageDesc(file_hitl_hitl, 7);

/**
 * @generated from message lvdr.v2.hitl.HITLCancelledEvent
 */
export type HITLCancelledEvent = Message<"lvdr.v2.hitl.HITLCancelledEvent"> & {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * @generated from field: string research_id = 2;
   */
  researchId: string;

  /**
   * @generated from field: string reason = 3;
   */
  reason: string;
};

/**
 * Describes the message lvdr.v2.hitl.HITLCancelledEvent.
 * Use `create(HITLCancelledEventSchema)` to create a new message.
 */
export const HITLCancelledEventSchema: GenMessage<HITLCancelledEvent> = /*@__PURE__*/
  messageDesc(file_hitl_hitl, 8);

/**
 * @generated from message lvdr.v2.hitl.HITLPendingResponse
 */
export type HITLPendingResponse = Message<"lvdr.v2.hitl.HITLPendingResponse"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: repeated lvdr.v2.hitl.HITLRequestEvent requests = 2;
   */
  requests: HITLRequestEvent[];

  /**
   * @generated from field: int32 count = 3;
   */
  count: number;
};

/**
 * Describes the message lvdr.v2.hitl.HITLPendingResponse.
 * Use `create(HITLPendingResponseSchema)` to create a new message.
 */
export const HITLPendingResponseSchema: GenMessage<HITLPendingResponse> = /*@__PURE__*/
  messageDesc(file_hitl_hitl, 9);

/**
 * @generated from message lvdr.v2.hitl.BudgetHITLEvent
 */
export type BudgetHITLEvent = Message<"lvdr.v2.hitl.BudgetHITLEvent"> & {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * @generated from field: string research_id = 2;
   */
  researchId: string;

  /**
   * @generated from field: string extension_type = 3;
   */
  extensionType: string;

  /**
   * @generated from field: double current_value = 4;
   */
  currentValue: number;

  /**
   * @generated from field: double requested_value = 5;
   */
  requestedValue: number;

  /**
   * @generated from field: string reason = 6;
   */
  reason: string;
};

/**
 * Describes the message lvdr.v2.hitl.BudgetHITLEvent.
 * Use `create(BudgetHITLEventSchema)` to create a new message.
 */
export const BudgetHITLEventSchema: GenMessage<BudgetHITLEvent> = /*@__PURE__*/
  messageDesc(file_hitl_hitl, 10);

/**
 * @generated from message lvdr.v2.hitl.GuidanceRequestEvent
 */
export type GuidanceRequestEvent = Message<"lvdr.v2.hitl.GuidanceRequestEvent"> & {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * @generated from field: string research_id = 2;
   */
  researchId: string;

  /**
   * @generated from field: repeated string topics = 3;
   */
  topics: string[];

  /**
   * @generated from field: string message = 4;
   */
  message: string;
};

/**
 * Describes the message lvdr.v2.hitl.GuidanceRequestEvent.
 * Use `create(GuidanceRequestEventSchema)` to create a new message.
 */
export const GuidanceRequestEventSchema: GenMessage<GuidanceRequestEvent> = /*@__PURE__*/
  messageDesc(file_hitl_hitl, 11);

/**
 * @generated from message lvdr.v2.hitl.QualityGateEvent
 */
export type QualityGateEvent = Message<"lvdr.v2.hitl.QualityGateEvent"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: string issue_type = 2;
   */
  issueType: string;

  /**
   * @generated from field: string node_id = 3;
   */
  nodeId: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: double severity = 5;
   */
  severity: number;
};

/**
 * Describes the message lvdr.v2.hitl.QualityGateEvent.
 * Use `create(QualityGateEventSchema)` to create a new message.
 */
export const QualityGateEventSchema: GenMessage<QualityGateEvent> = /*@__PURE__*/
  messageDesc(file_hitl_hitl, 12);

/**
 * @generated from message lvdr.v2.hitl.StopResearchEvent
 */
export type StopResearchEvent = Message<"lvdr.v2.hitl.StopResearchEvent"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: string reason = 2;
   */
  reason: string;

  /**
   * @generated from field: int32 total_issues = 3;
   */
  totalIssues: number;
};

/**
 * Describes the message lvdr.v2.hitl.StopResearchEvent.
 * Use `create(StopResearchEventSchema)` to create a new message.
 */
export const StopResearchEventSchema: GenMessage<StopResearchEvent> = /*@__PURE__*/
  messageDesc(file_hitl_hitl, 13);

/**
 * @generated from message lvdr.v2.hitl.ToolAuthRequestEvent
 */
export type ToolAuthRequestEvent = Message<"lvdr.v2.hitl.ToolAuthRequestEvent"> & {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * @generated from field: string research_id = 2;
   */
  researchId: string;

  /**
   * @generated from field: string tool_name = 3;
   */
  toolName: string;

  /**
   * @generated from field: google.protobuf.Struct params = 4;
   */
  params?: JsonObject | undefined;

  /**
   * @generated from field: string node_id = 5;
   */
  nodeId: string;
};

/**
 * Describes the message lvdr.v2.hitl.ToolAuthRequestEvent.
 * Use `create(ToolAuthRequestEventSchema)` to create a new message.
 */
export const ToolAuthRequestEventSchema: GenMessage<ToolAuthRequestEvent> = /*@__PURE__*/
  messageDesc(file_hitl_hitl, 14);

/**
 * ReportRunCostApproval is emitted by the GenerateReport handler when an
 * estimated report run cost meets or exceeds the user's
 * `report_run_auto_approve_credits` threshold. The user's approve/reject
 * decision reuses the standard HITLResponseMsg (matched by `request_id`);
 * approve dispatches the run, reject (or TTL expiry — see
 * LVDR_REPORT_RUN_HITL_TTL) flips the pre-created anchor node to Cancelled.
 *
 * @generated from message lvdr.v2.hitl.ReportRunCostApproval
 */
export type ReportRunCostApproval = Message<"lvdr.v2.hitl.ReportRunCostApproval"> & {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * @generated from field: string research_id = 2;
   */
  researchId: string;

  /**
   * @generated from field: string report_run_node_id = 3;
   */
  reportRunNodeId: string;

  /**
   * "writer_only" | "top_up" | "full_research" | "derivative"
   *
   * @generated from field: string mode = 4;
   */
  mode: string;

  /**
   * @generated from field: string label = 5;
   */
  label: string;

  /**
   * @generated from field: int64 estimated_credits = 6;
   */
  estimatedCredits: bigint;

  /**
   * "exact" | "bounded" | "heuristic"
   *
   * @generated from field: string confidence = 7;
   */
  confidence: string;

  /**
   * @generated from field: string breakdown = 8;
   */
  breakdown: string;
};

/**
 * Describes the message lvdr.v2.hitl.ReportRunCostApproval.
 * Use `create(ReportRunCostApprovalSchema)` to create a new message.
 */
export const ReportRunCostApprovalSchema: GenMessage<ReportRunCostApproval> = /*@__PURE__*/
  messageDesc(file_hitl_hitl, 15);

/**
 * @generated from message lvdr.v2.hitl.OffTopicDetectionEvent
 */
export type OffTopicDetectionEvent = Message<"lvdr.v2.hitl.OffTopicDetectionEvent"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: string node_id = 2;
   */
  nodeId: string;

  /**
   * @generated from field: string content_excerpt = 3;
   */
  contentExcerpt: string;

  /**
   * @generated from field: double confidence = 4;
   */
  confidence: number;

  /**
   * @generated from field: string detection_method = 5;
   */
  detectionMethod: string;
};

/**
 * Describes the message lvdr.v2.hitl.OffTopicDetectionEvent.
 * Use `create(OffTopicDetectionEventSchema)` to create a new message.
 */
export const OffTopicDetectionEventSchema: GenMessage<OffTopicDetectionEvent> = /*@__PURE__*/
  messageDesc(file_hitl_hitl, 16);

/**
 * @generated from message lvdr.v2.hitl.ResearchWrappingUpEvent
 */
export type ResearchWrappingUpEvent = Message<"lvdr.v2.hitl.ResearchWrappingUpEvent"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;
};

/**
 * Describes the message lvdr.v2.hitl.ResearchWrappingUpEvent.
 * Use `create(ResearchWrappingUpEventSchema)` to create a new message.
 */
export const ResearchWrappingUpEventSchema: GenMessage<ResearchWrappingUpEvent> = /*@__PURE__*/
  messageDesc(file_hitl_hitl, 17);

/**
 * Server->Client: enricher needs user clarification before proceeding.
 *
 * @generated from message lvdr.v2.hitl.EnricherClarificationRequestEvent
 */
export type EnricherClarificationRequestEvent = Message<"lvdr.v2.hitl.EnricherClarificationRequestEvent"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: string node_id = 2;
   */
  nodeId: string;

  /**
   * @generated from field: string task_id = 3;
   */
  taskId: string;

  /**
   * @generated from field: string question = 4;
   */
  question: string;

  /**
   * optional suggested answers
   *
   * @generated from field: repeated string options = 5;
   */
  options: string[];
};

/**
 * Describes the message lvdr.v2.hitl.EnricherClarificationRequestEvent.
 * Use `create(EnricherClarificationRequestEventSchema)` to create a new message.
 */
export const EnricherClarificationRequestEventSchema: GenMessage<EnricherClarificationRequestEvent> = /*@__PURE__*/
  messageDesc(file_hitl_hitl, 18);

/**
 * Client->Server: user responds to an enricher clarification request.
 *
 * @generated from message lvdr.v2.hitl.EnricherClarificationResponseMsg
 */
export type EnricherClarificationResponseMsg = Message<"lvdr.v2.hitl.EnricherClarificationResponseMsg"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: string task_id = 2;
   */
  taskId: string;

  /**
   * @generated from field: string answer = 3;
   */
  answer: string;
};

/**
 * Describes the message lvdr.v2.hitl.EnricherClarificationResponseMsg.
 * Use `create(EnricherClarificationResponseMsgSchema)` to create a new message.
 */
export const EnricherClarificationResponseMsgSchema: GenMessage<EnricherClarificationResponseMsg> = /*@__PURE__*/
  messageDesc(file_hitl_hitl, 19);

/**
 * Enums
 *
 * @generated from enum lvdr.v2.hitl.Decision
 */
export enum Decision {
  /**
   * @generated from enum value: DECISION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DECISION_APPROVE = 1;
   */
  APPROVE = 1,

  /**
   * @generated from enum value: DECISION_REJECT = 2;
   */
  REJECT = 2,

  /**
   * @generated from enum value: DECISION_MODIFY = 3;
   */
  MODIFY = 3,

  /**
   * @generated from enum value: DECISION_ABORT = 4;
   */
  ABORT = 4,
}

/**
 * Describes the enum lvdr.v2.hitl.Decision.
 */
export const DecisionSchema: GenEnum<Decision> = /*@__PURE__*/
  enumDesc(file_hitl_hitl, 0);

